<template>
	<div class="radio">
		<div v-for="(option, index) in options" :key="index">
			<label :for="option.value" class="radio__wrapper">
				<input
					type="radio"
					:value="option.value"
					:name="option.value"
					v-model="inputVal"
					:id="option.value"
					class="radio__input"
					checked
				/>

				<div class="radio__radio"></div>
				<span class="radio__label text-small"> {{ option.label }}</span>
			</label>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		value: String,
		options: {
			type: Array,
			default: () => [
				{ label: 'Bedrift', value: 'bedrift' },
				{ label: 'Privat', value: 'privat' },
			],
		},
	},
	computed: {
		inputVal: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		},
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_color.scss';
@import '@/styles/base/_variables.scss';

.radio {
	color: $primary;
	display: flex;
	flex-wrap: nowrap;
	gap: 1rem;
	justify-content: left;

	&__wrapper {
		cursor: pointer;
		display: inline-flex;
		margin-right: 10px;
	}
	.radio__input {
		display: none;
	}
	.radio__radio {
		$size: 21px;
		width: $size;
		height: $size;
		border: 1px solid $dark-grey;
		border-radius: 50%;
		margin-right: 10px;
		box-sizing: border-box;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.radio__label {
		align-self: flex-end;
		font-size: 16px !important;
	}
	.radio__radio::after {
		content: '';
		width: 13px;
		height: 13px;
		display: block;
		background: $primary;
		border-radius: 50%;
		opacity: 0;
	}
	.radio__input:checked + .radio__radio::after {
		opacity: 1;
	}
}
</style>
